import { render, staticRenderFns } from "./addchanForm.vue?vue&type=template&id=a424a19a&scoped=true"
import script from "./addchanForm.vue?vue&type=script&lang=js"
export * from "./addchanForm.vue?vue&type=script&lang=js"
import style0 from "./addchanForm.vue?vue&type=style&index=0&id=a424a19a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a424a19a",
  null
  
)

export default component.exports